import { z } from 'zod';
import { FeatureSchema } from './features.js';
import { IdSchema, TimestampSchema } from './common.js';
import { PermissionSchema } from './permissions.js';
export const SessionRoleSchema = z.strictObject({
    id: IdSchema,
    name: z.string(),
});
export const SessionOrganizationSchema = z.strictObject({
    id: IdSchema,
    name: z.string(),
    slug: z.string(),
    roles: z.array(SessionRoleSchema),
});
export const SessionIdentitySchema = z.strictObject({
    id: IdSchema,
    email: z.email().nullable(),
    displayName: z.string(),
});
export const CurrentSessionSchema = z.strictObject({
    identity: SessionIdentitySchema,
    activeOrganizationId: IdSchema,
    organizations: z.array(SessionOrganizationSchema).min(1),
    permissions: z.array(PermissionSchema),
    /**
     * Application areas enabled for this deployment. The server decides; the web
     * app uses it to build navigation and routes. Never a security boundary —
     * permissions are, and they are enforced independently on every endpoint.
     */
    features: z.array(FeatureSchema),
    expiresAt: TimestampSchema,
});
export const SwitchOrganizationRequestSchema = z.strictObject({
    organizationId: IdSchema,
});
/**
 * Email and password sign-in. See ADR 0007.
 *
 * The organization is not a field: this is a single-client portal and the API
 * resolves the caller's membership itself.
 */
export const PasswordLoginRequestSchema = z.strictObject({
    email: z.email().max(320),
    password: z.string().min(1).max(200),
});
export const DevelopmentLoginRequestSchema = z.strictObject({
    email: z.email(),
    displayName: z.string().trim().min(1).max(200),
    organizationSlug: z
        .string()
        .trim()
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
});
